export const merchantArray = [
  {
    img: 'https://iccdn.in/merchant/img/sangeetha-2x.png',
    name: 'Sangeetha Mobiles',
  },
  {
    img: 'https://iccdn.in/img/merchant-studyiq.jpg',
    name: 'Study IQ',
  },
  {
    img: 'https://iccdn.in/img/merchant-hidesign.jpg',
    name: 'Hidesign',
  },
  {
    img: 'https://iccdn.in/img/merchant-primeabgb-logo.jpg',
    name: 'Prime Abgb',
  },
  {
    img: 'https://iccdn.in/img/merchant-crocs.jpg',
    name: 'Crocs',
  },

  {
    img: 'https://iccdn.in/merchant/img/merchant-Bajaj+Electricals.png',
    name: 'Bajaj Electricals',
  },

  {
    img: 'https://iccdn.in/img/merchant-internshala.jpg',
    name: 'Internshala',
  },
  {
    img: 'https://iccdn.in/merchant/img/merchant-gurumann.png',
    name: 'GM Nutrition',
  },
  {
    img: 'https://iccdn.in/merchant/img/merchant-hummel.png',
    name: 'Hummel India',
  },
  {
    img: 'https://iccdn.in/merchant/img/merchant-hifimart.png',
    name: 'Hifi Mart',
  },

  {
    img: 'https://iccdn.in/merchant/img/merchant-panasonic.png',
    name: 'Panasonic India Private Limited',
  },
  {
    img: 'https://iccdn.in/merchant/img/merchant-sennheiser.png',
    name: 'Sennheiser',
  },
  {
    img: 'https://iccdn.in/merchant/img/merchant-vlccpersonalcare.png',
    name: 'VLCC PERSONAL CARE LTD',
  },
];

export const iciciEducationMerchants = [
  {
    img: 'https://iccdn.in/campaigns/icici-educational/coursera.png',
    name: 'coursera',
  },
  {
    img: 'https://iccdn.in/campaigns/icici-educational/jigsaw.png',
    name: 'jigsaw',
  },
  {
    img: 'https://iccdn.in/campaigns/icici-educational/classplus.png',
    name: 'classplus',
  },
  {
    img: 'https://iccdn.in/campaigns/icici-educational/unacademy.png',
    name: 'unacademy',
  },

  {
    img: 'https://iccdn.in/campaigns/icici-educational/coding-ninjas.png',
    name: 'coding ninjas',
  },

  {
    img: 'https://iccdn.in/campaigns/icici-educational/cuemath.png',
    name: 'cuemath',
  },
  {
    img: 'https://iccdn.in/campaigns/icici-educational/intellipaat.png',
    name: 'intellipaat',
  },
  {
    img: 'https://iccdn.in/campaigns/icici-educational/pesto.png',
    name: 'pesto',
  },
  {
    img: 'https://iccdn.in/campaigns/icici-educational/meritnation.png',
    name: 'meritnation',
  },
  {
    img: 'https://iccdn.in/campaigns/icici-educational/testbook.png',
    name: 'testbook',
  },

  {
    img: 'https://iccdn.in/campaigns/icici-educational/vedantu.png',
    name: 'vedantu',
  },
  {
    img: 'https://iccdn.in/campaigns/icici-educational/collegedunia.png',
    name: 'collegedunia',
  },
  {
    img: 'https://iccdn.in/campaigns/icici-educational/ask-iitians.png',
    name: 'ask-iitians',
  },
  {
    img: 'https://iccdn.in/campaigns/icici-educational/lido.png',
    name: 'lido',
  },

  {
    img: 'https://iccdn.in/campaigns/icici-educational/physics-wallah.png',
    name: 'physics wallah',
  },
  {
    img: 'https://iccdn.in/campaigns/icici-educational/filo.png',
    name: 'filo',
  },
  {
    img: 'https://iccdn.in/campaigns/icici-educational/adda247.png',
    name: 'adda 24/7',
  },
];



// WEBPACK FOOTER //
// ./routes/campaign-fast-feature/constants/index.js